"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _overrides = require("../../../utils/overrides");

var _Chip = _interopRequireDefault(require("./../Chip"));

var _styles = require("../../../utils/styles");

var _styles2 = _interopRequireDefault(require("./styles"));

var useStyles = (0, _styles.createUseStyles)(_styles2.default, 'ChipGrou');

function ChipGroup(_ref) {
  var className = _ref.className,
      classesProp = _ref.classes,
      overridesProp = _ref.overrides,
      label = _ref.label,
      url = _ref.url,
      isShrinked = _ref.isShrinked,
      chips = _ref.chips,
      props = (0, _objectWithoutProperties2.default)(_ref, ["className", "classes", "overrides", "label", "url", "isShrinked", "chips"]);
  var classes = (0, _overrides.useClasses)(useStyles, classesProp);
  var override = (0, _overrides.getOverrides)(overridesProp, ChipGroup.overrides);
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: classes.root
  }, override.root), chips.map(function (chip, index) {
    return /*#__PURE__*/_react.default.createElement(_Chip.default, {
      key: index,
      url: chip.url,
      isShrinked: true
    }, chip.label);
  }));
}

_Chip.default.overrides = ['root'];
ChipGroup.defaultProps = {
  className: '',
  overrides: {},
  chips: []
};
process.env.NODE_ENV !== "production" ? ChipGroup.propTypes = {
  className: _propTypes.default.string,
  overrides: _propTypes.default.object,
  chips: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    url: _propTypes.default.string
  }))
} : void 0;

var _default = /*#__PURE__*/_react.default.memo(ChipGroup);

exports.default = _default;